<div
  class="border border-gray-200 rounded-lg p-4 transform transition ease-in-out hover:scale-[102%] cursor-pointer">
  <ng-content></ng-content>
</div>
